export default __webpack_public_path__ + "static/img-success-story-the-economist-83210d3995369cf8be66eb5680150e02.jpg";